module.exports = __webpack_public_path__ + "img/earth.3050f783.png";